(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oddfish-black-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";

  function initSection(section) {
    if (section.dataset.oddfishFaqBound) return;
    section.dataset.oddfishFaqBound = "true";

    var titles = section.querySelectorAll(".faq_title");

    titles.forEach(function (title) {
      if (title.dataset.oddfishFaqClickBound) return;
      title.dataset.oddfishFaqClickBound = "true";

      title.addEventListener("click", function () {
        var faqKey = title.getAttribute("data-attr") || title.getAttribute("data-faq");
        var answer = faqKey
          ? section.querySelector("." + faqKey + ", [data-faq-answer='" + faqKey + "']")
          : null;
        var chevron = title.querySelector(".close, .faq_chevron");
        var isOpen = title.classList.contains("open");

        titles.forEach(function (t) {
          t.classList.remove("open");
          t.setAttribute("aria-expanded", "false");
          var icon = t.querySelector(".close, .faq_chevron");
          if (icon) icon.classList.remove("open");
        });
        section.querySelectorAll(".faq_answer, .tab_content").forEach(function (a) {
          a.classList.remove("active");
        });

        if (!isOpen && answer) {
          title.classList.add("open");
          title.setAttribute("aria-expanded", "true");
          if (chevron) chevron.classList.add("open");
          answer.classList.add("active");
        }
      });
    });

    if (section.classList.contains("animate") && !section.classList.contains("scrolled")) {
      var rect = section.getBoundingClientRect();
      var viewHeight = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < viewHeight * 0.92 && rect.bottom > 0) {
        section.classList.add("scrolled");
      }
    }
  }

  function boot() {
    document.querySelectorAll(".oddfish-black-faq, .services_fifth_section").forEach(initSection);
  }

  if (window.oddfishBlackFaqInit) {
    boot();
  } else {
    window.oddfishBlackFaqInit = true;
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
    document.addEventListener("shopify:section:load", function (event) {
      var section = event.target.querySelector(".oddfish-black-faq, .services_fifth_section");
      if (section) initSection(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
